import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { FlexLayoutModule } from "@angular/flex-layout";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";

import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { AlertDialogComponent } from "./alert-dialog/alert-dialog.component";
import { PasswordDialogComponent } from "./password-dialog/password-dialog.component";
import { AboutDialogComponent } from "./about-dialog/about-dialog.component";
import { DescriptionLocaleFormDialogComponent } from "./description-locale-form-dialog/description-locale-form-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatDialogModule,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FlexLayoutModule,
  ],
  exports: [
    ConfirmationDialogComponent,
    AlertDialogComponent,
    PasswordDialogComponent,
    AboutDialogComponent,
    DescriptionLocaleFormDialogComponent,
  ],
  declarations: [
    ConfirmationDialogComponent,
    AlertDialogComponent,
    PasswordDialogComponent,
    AboutDialogComponent,
    DescriptionLocaleFormDialogComponent,
  ],
})
export class DialogModule {}
